import React from 'react';
import CollectionImages from '../../data/CollectionImages';
import { CollectionHeaderBottom, CollectionHeaderBottomWrapper, CollectionHeaderContent, CollectionHeaderWrapper, CollectionImage, CollectionInfo, CollectionLikeCount, CollectionShowOnSaleToggle, CollectionSocial, CollectionSocialItem, CollectionStatisticItem, CollectionTitle } from './styled';
import { ReactComponent as VerifiedIcon } from '../../../../assets/svg/verified.svg'
import { ReactComponent as AlertIcon } from '../../../../assets/svg/alert.svg'
import { ReactComponent as ForkIcon } from '../../../../assets/svg/git-fork.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faTelegram, faDiscord } from "@fortawesome/free-brands-svg-icons";
import { faGlobe, faHeart } from "@fortawesome/free-solid-svg-icons";
import CopyAddress from '../../newComponents/CopyAddress';
import { getWalletAddress } from '../../utils/NFTFormatedData';
import { INFTCollectionSaleList, INFTCollectionStatistic } from '../../models/INFTCollections';
import { formatEther } from 'ethers/lib/utils';
import { getCollectionHolders, getCollectionPrice, getCollectionTotalVolume } from '../../../../services/NFTMarketPlace/Graphquery';
import AvaxLogo from '../../../../assets/images/avalanche_token_round.png'
import YTSLogo from '../../../../assets/logo/token-logo.png'
import Collapse from '../../newComponents/Collapse';
import useCollectionLike from '../../data/useCollectionLike';
import cx from '../../../../utils/cx';
import { loadCollectionLikeCounts } from '../../data/useNFTLikeCount';
import ToggleSwitch from '../../newComponents/ToggleSwitch';
import BG1 from './images/bg1.svg';
import BG2 from './images/bg2.svg';
import BG3 from './images/bg3.svg';
import BG4 from './images/bg4.svg';

const CollectionBGs = [
    BG1,
    BG2,
    BG3,
    BG4
]

const getRandomBG = () => {
    const randomIndex = Math.floor(Math.random() * CollectionBGs.length);
    return CollectionBGs[randomIndex];
};

const CollectionPageHeader = (props: any) => {
    const { collection } = props;
    //@ts-ignore
    const collectionImgSrc = collection && collection.logo?.startsWith("http") ? (collection.logo) : CollectionImages["YetiSwap"];
    const [collectionStatistic, setCollectionStatistic] = React.useState<INFTCollectionStatistic | null>(null)
    const { action, isLiked, likeCount, actionTitle } = useCollectionLike(collection?.tokenAddress.toLowerCase());
    const [bg] = React.useState<string>(getRandomBG());
    const [collectionHolders, setCollectionHolders] = React.useState<{ numTokens: string, numOwners: string }>();

    const getAverageSalePrice = React.useCallback((statistic?: INFTCollectionSaleList[]) => {
        let result = {
            totalVolume: 'N\\A',
            averageSale: 'N\\A'
        }

        if (statistic) {
            const totalVolume = statistic.reduce((a: number, b: INFTCollectionSaleList) => {
                return a + parseFloat(formatEther(b.price))
            }, 0)

            result = {
                totalVolume: totalVolume ? totalVolume.toFixed(2).toString() : 'N\\A',
                averageSale: totalVolume ? (totalVolume / statistic.length).toFixed(2).toString() : 'N\\A'
            }
        }
        return result
    }, []);


    React.useEffect(() => {
        if (collection?.tokenAddress) {
            loadCollectionLikeCounts([{ collectionAddress: collection.tokenAddress.toLowerCase() }])
            Promise.all([
                getCollectionPrice(collection.tokenAddress, '0x488f73cddda1de3664775ffd91623637383d6404', 'asc', 1).then(
                    res => res
                ),
                getCollectionPrice(collection.tokenAddress, '0x488f73cddda1de3664775ffd91623637383d6404', 'desc', 2).then(
                    res => res
                ),
                getCollectionPrice(collection.tokenAddress, '0x0000000000000000000000000000000000000000', 'asc', 1).then(
                    res => res
                ),
                getCollectionPrice(collection.tokenAddress, '0x0000000000000000000000000000000000000000', 'desc', 2).then(
                    res => res
                ),
                getCollectionTotalVolume(collection.tokenAddress, '0x488f73cddda1de3664775ffd91623637383d6404').then(res => res),
                getCollectionTotalVolume(collection.tokenAddress, '0x0000000000000000000000000000000000000000').then(res => res)
            ]).then(values => {
                const ytsStatistic = getAverageSalePrice(values[4])
                const avaxStatistic = getAverageSalePrice(values[5])
                setCollectionStatistic({
                    ytsFloorPrice: values[0] ? formatEther(values[0]).toString() : 'N\\A',
                    ytsTopPrice: values[1] ? formatEther(values[1]).toString() : 'N\\A',
                    ytsAveragePrice: ytsStatistic.averageSale,
                    ytsTotalVolume: ytsStatistic.totalVolume,
                    avaxFloorPrice: values[2] ? formatEther(values[2]).toString() : 'N\\A',
                    avaxTopPrice: values[3] ? formatEther(values[3]).toString() : 'N\\A',
                    avaxAveragePrice: avaxStatistic.averageSale,
                    avaxTotalVolume: avaxStatistic.totalVolume
                })
            })
            getCollectionHolders(collection.tokenAddress).then(res => {
                if (res) {
                    setCollectionHolders({
                        numTokens: res.numTokens,
                        numOwners: res.numOwners
                    });
                }
            });
        }
    }, [collection?.tokenAddress])

    return (
        <CollectionHeaderWrapper>
            <CollectionHeaderContent style={{ backgroundImage: `url(${bg})` }}>
                <CollectionImage title={props.collection?.name + " Verified Collection"}>
                    <img src={collectionImgSrc} alt={props.collection?.name} height={150} width={150} />
                </CollectionImage>
                <CollectionInfo>
                    <CollectionTitle>
                        {collection?.forkProject && (
                            <ForkIcon width="1.2rem" height="1.2rem" className="fork-icon" title="Forked Collection" />
                        )}
                        {collection?.oldProject && (
                            <AlertIcon width="1.2rem" height="1.2rem" className="fork-icon" title="Old Project, You need to migrate new version" />
                        )}
                        <VerifiedIcon width="1.5rem" />
                        {props.collection?.name}
                    </CollectionTitle>
                    {collection && <CopyAddress text={getWalletAddress(collection.tokenAddress, 12)} address={collection.tokenAddress} />}
                </CollectionInfo>
                <CollectionSocial>
                    {collection?.website && (
                        <CollectionSocialItem href={collection.website} title={collection.website} target={"_blank"}>
                            <FontAwesomeIcon icon={faGlobe} />
                        </CollectionSocialItem>
                    )}
                    {collection?.twitter && (
                        <CollectionSocialItem href={`https://twitter.com/${collection.twitter}`} title={`https://twitter.com/${collection.twitter}`} target={"_blank"}>
                            <FontAwesomeIcon icon={faTwitter} />
                        </CollectionSocialItem>
                    )}
                    {collection?.telegram && (
                        <CollectionSocialItem href={collection.telegram} title={collection.telegram} target={"_blank"}>
                            <FontAwesomeIcon icon={faTelegram} />
                        </CollectionSocialItem>
                    )}
                    {collection?.discord && (
                        <CollectionSocialItem href={collection.discord} title={collection.discord} target={"_blank"}>
                            <FontAwesomeIcon icon={faDiscord} />
                        </CollectionSocialItem>
                    )}
                    <CollectionLikeCount className={cx({ liked: isLiked })} title={actionTitle} onClick={action}>
                        <FontAwesomeIcon icon={faHeart} size={"1x"} />
                        {likeCount > 0 && <div>{likeCount}</div>}
                    </CollectionLikeCount>
                </CollectionSocial>
            </CollectionHeaderContent>
            <CollectionHeaderBottomWrapper>
                <CollectionShowOnSaleToggle>{"Show On Sale: "}<ToggleSwitch small onChange={props.onShowOnSaleChange} checked={props.showOnSale} /></CollectionShowOnSaleToggle>
                {collectionStatistic && (
                    <Collapse title='Collection Statistics'>
                        <CollectionHeaderBottom>
                            <CollectionHeaderBottom>
                                <CollectionStatisticItem>
                                    <span>Floor Price</span>
                                    <div>{collectionStatistic.ytsFloorPrice}<img src={YTSLogo} alt="YTS Logo" /></div>
                                </CollectionStatisticItem>
                                <CollectionStatisticItem>
                                    <span>Top Price</span>
                                    <div>{collectionStatistic.ytsTopPrice}<img src={YTSLogo} alt="YTS Logo" /></div>
                                </CollectionStatisticItem>
                                <CollectionStatisticItem>
                                    <span>Avg Price</span>
                                    <div>{collectionStatistic.ytsAveragePrice}<img src={YTSLogo} alt="YTS Logo" /></div>
                                </CollectionStatisticItem>
                                <CollectionStatisticItem>
                                    <span>Total Volume</span>
                                    <div>{collectionStatistic.ytsTotalVolume}<img src={YTSLogo} alt="YTS Logo" /></div>
                                </CollectionStatisticItem>
                            </CollectionHeaderBottom>
                            <CollectionHeaderBottom>
                                <CollectionStatisticItem>
                                    <span>Floor Price</span>
                                    <div>{collectionStatistic.avaxFloorPrice}<img src={AvaxLogo} alt="Avax Logo" /></div>
                                </CollectionStatisticItem>
                                <CollectionStatisticItem>
                                    <span>Top Price</span>
                                    <div>{collectionStatistic.avaxTopPrice}<img src={AvaxLogo} alt="Avax Logo" /></div>
                                </CollectionStatisticItem>
                                <CollectionStatisticItem>
                                    <span>Avg Price</span>
                                    <div>{collectionStatistic.avaxAveragePrice}<img src={AvaxLogo} alt="Avax Logo" /></div>
                                </CollectionStatisticItem>
                                <CollectionStatisticItem>
                                    <span>Total Volume</span>
                                    <div>{collectionStatistic.avaxTotalVolume}<img src={AvaxLogo} alt="Avax Logo" /></div>
                                </CollectionStatisticItem>
                            </CollectionHeaderBottom>
                            {collectionHolders && (
                                <>
                                    <CollectionStatisticItem>
                                        <span>Total NFTs</span>
                                        <div>{collectionHolders.numTokens}</div>
                                    </CollectionStatisticItem>
                                    <CollectionStatisticItem>
                                        <span>Total Holders</span>
                                        <div>{collectionHolders.numOwners}</div>
                                    </CollectionStatisticItem>
                                </>
                            )}
                        </CollectionHeaderBottom>
                    </Collapse>
                )}
            </CollectionHeaderBottomWrapper>

        </CollectionHeaderWrapper>
    )
}

export default CollectionPageHeader;